export default function min(text?: string) {
    return (text || '')
        .trim()
        .split('\n')
        .map(s => s.trim())
        .join('')
}
